import {
  OrderListQueryVariables,
  useOrderListLazyQuery,
  useOrdersBySellableItemQuery,
  useOrdersBySellableItemsSummaryQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { useEffect, useMemo } from "react"
import { Modules } from "store"
import { useCurrentDc } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { getId } from "utils/custom.utils"

export const useModuleDcs = (module: Modules) => {
  const [filter] = useFilter(module)
  const [dc] = useCurrentDc()

  return filter?.distributionCentreIds?.length > 0
    ? filter?.distributionCentreIds
    : [dc]
}
export const useOrderVariables = (): OrderListQueryVariables => {
  const [{ search, page }] = useSearchFilter()
  const [filter] = useFilter("orders")
  const dcs = useModuleDcs("orders")
  const deptId = filter?.placedInId?.id
  return useMemo(
    () => ({
      query: search,
      first: 15,
      skip: page * 15,
      filter: {
        distributionCentreIds: dcs?.map(getId),
        ...(deptId && { placedInId: deptId }),
        pickupDate_Gte: filter?.pickupDateRange?.[0],
        pickupDate_Lte: filter?.pickupDateRange?.[1],
        date_Gte: filter?.dateRange?.[0],
        date_Lte: filter?.dateRange?.[1],
        paymentStatus: filter?.paymentStatus?.map((p: any) => p?.id),
        deliveryStatus: filter?.deliveryStatus?.map((p: any) => p?.id),
        orderStatus: filter?.orderStatus?.map((p: any) => p?.id),
        placedById: filter?.placedById?.map(getId),
        paymentMethods: filter?.paymentMethods?.map((p: any) => p?.id),
        salesmanId: filter?.salesmanId?.id,
        orderCategories: filter?.orderCategories?.map((p: any) => p?.id),
      },
    }),
    [filter, search, deptId, page, dcs]
  )
}
export const useOrderList = () => {
  const variables = useOrderVariables()
  const variablesString = JSON.stringify(variables)

  const [fetch, response] = useOrderListLazyQuery()

  useEffect(() => {
    const vars = JSON.parse(variablesString)

    // Only query is placedInId is set
    if (vars?.filter?.placedInId) {
      fetch({ variables: vars })
    }
    // Variables are converted to string because the useEffectHook works more reliably with strings
  }, [variablesString, fetch])
  return response
}

export const useOrdersBySellableItem = () => {
  const variables = useOrderVariables()
  return useOrdersBySellableItemQuery({
    variables,
  })
}

export const useOrdersBySellableItemSummary = () => {
  const variables = useOrderVariables()
  return useOrdersBySellableItemsSummaryQuery({ variables })
}
